import Vue from 'vue'
import firebase from 'firebase/compat/app'
import App from './App.vue'
import router from './router'
import store from './store/index'
import events from './services/events/messagesPlatform'
import './registerServiceWorker'
import './vendor'
import './styles'
import 'moment/locale/es'
import config from '@/config'
import i18n from '@/i18n'

// Firebase init
firebase.initializeApp(config.firebase)

// Vue app init
export const app = new Vue({
  created () {
    events.listenerOnClickInProject()
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
